import React, { useEffect, useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { isEmpty } from 'lodash'

import { AppState, apphistory } from '../../../store'
import { ICalculateLoanParams, ILoanInitCreateApplicationParams, loanInitService } from '../../../service/LoanInitService'
import { SET_LOAN_CALCULATE_PARAMS, SET_LOAN_LIMITS, TOGGLE_CALCULATOR_OPEN } from '../../../store/actions/loan-calculator-actions'
import { BasicInfoFieldsNames } from '../../../formDefinitions/BasicInfo/BasicInfoFields'
import { APP_CONSENTS_VALIDATE_ALL } from '../../../store/actions/consent-action'
import { SessionStorage } from '../../../common/cookie-storage'
import { STORAGEKEYS } from '../../../common/keys'
import { AppLinks } from '../../../environment/app-links'
import { useQuery } from '../../../common/useQuery'
import { basicInfoForm } from '../../../formDefinitions/BasicInfo/BasicInfoForm'
import { CurrentFormUrlPathContext } from '../../AppRoot/hooks/useAppRootLogic'
import { FormNames } from '../../../models/form/IFormDefinition'
import { Environment } from '../../../environment/app-settings'
import { IBasicFormQueryParams, IBasicInfoFormLogicReturnModel } from '../models/IFormStepsModel'
import Cookies from 'universal-cookie'
import { IAffiliateDataModel } from '../../../models/form/IFormSubmitionModel'
import { affiliateAlternativeOffert, enablePredefinedPeriodsLogicForAffiliatePartner } from '../../AffiliatePage/affiliatePartnersData'
import { ApplicationStates } from '../../../components/organisms/Sidebar/pageStepperData'
import useAppInitLogic from '../../../hooks/useAppInitLogic'
import { APP_INIT_TYPES } from '../../../hooks/HooksProps'
import { retryRequestOnError } from '../../../common/helpers/helpers'
import { SET_APP_HAS_ERROR, SET_CURRENT_SELECTED_PREDEFINED_PERIOD } from '../../../store/actions/application-actions'
import analyticsService from '../../../service/analytics.service'
import { FormInitializationProps } from './FormHooksProps'
import { PREDEFINED_PERIODS_OFFER_LOGIC } from '../../../store/types'

/**
 * Funkcja inicjalizująca proces OPENY z formularzem. Pobiera i zapisuje w stanie aplikacji zgody 
 * oraz wszystkie niezbędne dane dla kalkulatora pożyczki  
*/

const formInitialization = async (props: FormInitializationProps) => {
   const cookie = new Cookies()
   const affiliateData: IAffiliateDataModel | undefined = cookie.get(STORAGEKEYS.FORM_AFFILIATE_DATA_COOKIE)
   const { dispatch, loanInitService, basicInfoQueryParams, loanCalculatorState, IS_PREDEFINED_PERIODS_AVAILABLE } = props

   try {
      const { requestedAmountFromParams, instalmentsFromParams } = basicInfoQueryParams
      // const loanLimitsParams = await loanInitService.getLoanLimits() //TODO Poprawić endpoint dla zadania 77206 - dodać możliwość zwracania różnych limitów pożyczki

      // const calculateLoanParams: ICalculateLoanParams = {
      //    instalments: loanLimitsParams.maxInstalments,
      //    requestedAmount: loanLimitsParams.maxRequestedAmount
      // }

      const calculateLoanParams: ICalculateLoanParams = {
         instalments: IS_PREDEFINED_PERIODS_AVAILABLE? loanInitService.defaultInstalmentsNumberForPredefinedPeriods : loanInitService.defaultInstalmentsNumber,
         requestedAmount: IS_PREDEFINED_PERIODS_AVAILABLE? loanInitService.defaultRequestedAmountForPredefinedPeriods :  loanInitService.defaultRequestedAmount
      }

      /**
       * !IMPORTANT Użytkownik wszedł z KALKULATORA POŻYCZKI NA STRONIE WIZYTÓWCE OPENY - 
       * w tej sytuacji przechwytujemy wybrane przez niego parametry pożyczki
      */
      if(requestedAmountFromParams !== null && instalmentsFromParams !== null){ // Sprawdzamy czy parametry zostały przekazane
         if(!isNaN(parseInt(requestedAmountFromParams)) && !isNaN(parseInt(instalmentsFromParams))) { //Jeśli da się je parsować jako liczbę
            apphistory.replace(AppLinks.basicInfoForm) // Ucinamy parametry z linku  
            
            calculateLoanParams.instalments = parseInt(instalmentsFromParams)
            calculateLoanParams.requestedAmount = parseInt(requestedAmountFromParams)


            // [ZAŁOŻENIE BIZNESOWE] - MECHANIZM PREDEFINIOWANYCH OKRESÓW POŻYCZKI
            // Gdy dostępny oraz gdy ilość rat z parametru w linku zgadza się z ilością z obiektu predefiniowanych rat
            // nadpisujemy wybrany okres i zapisujemy go w state
            if(IS_PREDEFINED_PERIODS_AVAILABLE === true) {
               const predefinedPeriodOfferName = Object.entries(Environment.PREDEFINED_PERIODS_OFFER_LOGIC_INSTALMENT_MAP)
                  .find(([_, predefinedPeriodOfferValue]) => predefinedPeriodOfferValue === calculateLoanParams.instalments)?.[0]

               if(predefinedPeriodOfferName !== undefined && Object.keys(PREDEFINED_PERIODS_OFFER_LOGIC).includes(predefinedPeriodOfferName)) {
                  dispatch({
                     type: SET_CURRENT_SELECTED_PREDEFINED_PERIOD,
                     payload: predefinedPeriodOfferName
                  })
               }

               // W momencie gdy nie uda się znaleźć przekazanej w parametrze raty w obiekcie predefiniowanych ofert, 
               // DOMYŚLNIE BIERZEMY NAJDŁUŻSZY DOSTĘPNY OKRES I DLA NIEGO KONTYNUUJEMY PRZELICZANIE OFERTY
               else {
                  const calculateLoanInstalmentFromPredefinedPeriods = Environment.PREDEFINED_PERIODS_OFFER_LOGIC_INSTALMENT_MAP[PREDEFINED_PERIODS_OFFER_LOGIC.LONG_PERIOD]
                  calculateLoanParams.instalments = calculateLoanInstalmentFromPredefinedPeriods

                  dispatch({
                     type: SET_CURRENT_SELECTED_PREDEFINED_PERIOD,
                     payload: PREDEFINED_PERIODS_OFFER_LOGIC.LONG_PERIOD
                  })
               }
            }
         }
         dispatch({
            type: TOGGLE_CALCULATOR_OPEN,
            payload: false
         })
      }
      dispatch({
         type: TOGGLE_CALCULATOR_OPEN,
         payload: false
      })
      
      if(loanCalculatorState.isOffertAlreadySet){ // Sytuacja w której użytkownik wszedł z linku afiliacyjnego z ODPOWIEDNIM PARAMETREM i MA JUŻ USTAWIONĄ OFERTĘ
         const  alternativeOffertCalculateParams = { requestedAmount: loanCalculatorState.requestedAmount, instalments: loanCalculatorState.instalments }
         
         if(requestedAmountFromParams !== null && instalmentsFromParams !== null) {
            alternativeOffertCalculateParams.instalments = parseInt(instalmentsFromParams)
            alternativeOffertCalculateParams.requestedAmount = parseInt(requestedAmountFromParams)
         }

         const alternativeLoanOffert = await loanInitService.calculateLoanOffert(alternativeOffertCalculateParams)

         dispatch({
            type: SET_LOAN_CALCULATE_PARAMS,
            payload: alternativeLoanOffert
         })
      }
      else if (affiliateData?.alternativeOffertNameFromFront){ // Sytuacja w której użytkownik wchodzi ponownie na stronę, po czasie i ma jeszcze zapisane ciasteczko
         const alternativeOffertParams = affiliateAlternativeOffert[affiliateData.alternativeOffertNameFromFront]
         const  alternativeOffertCalculateParams = { requestedAmount: alternativeOffertParams.defaultLoanAmount, instalments: alternativeOffertParams.defaultInstalments }
         
         if(requestedAmountFromParams !== null && instalmentsFromParams !== null) {
            alternativeOffertCalculateParams.instalments = parseInt(instalmentsFromParams)
            alternativeOffertCalculateParams.requestedAmount = parseInt(requestedAmountFromParams)
         }

         const alternativeLoanOffert = await loanInitService.calculateLoanOffert(alternativeOffertCalculateParams)

         dispatch({
            type: SET_LOAN_LIMITS,
            payload: alternativeOffertParams.loanParams
         })
         
         dispatch({
            type: SET_LOAN_CALCULATE_PARAMS,
            payload: alternativeLoanOffert
         })
      }
      else {// Sytuacja w której żadne domyślne parametry oferty NIE ZOSTAŁY jeszcze podane (brak odpowiedniej oferty ustawionej za pomocą parametru z linku afiliacyjnego)
         //Wstępne przeliczenie - używamy maksymalnych dostępnych parametrów pożyczki lub tych podanych przez użytkownika na stronie wizytówce
         const initialLoanOffert = await loanInitService.calculateLoanOffert(calculateLoanParams)

         dispatch({
            type: SET_LOAN_LIMITS,
            payload: loanInitService.loanLimitsForDefaultOffert
         })

         dispatch({
            type: SET_LOAN_CALCULATE_PARAMS,
            payload: initialLoanOffert
         })   
      }
   }
   catch(e: any){
      throw e
   }
}


/**
 * Custom hook z logiką obsługującą pierwszą stronę formularza.
 * @returns 
 */
const useBasicInfoFormLogic = (): IBasicInfoFormLogicReturnModel => {
   const dispatch = useDispatch()
   const cookie = new Cookies()
   const sessionStorage = new SessionStorage()
   const basicFormQuery = useQuery()
   const ANALYTICS_EVENT_TYPES_NAMES = useSelector((state: AppState) => state.lenConfigState.analyticsEventTypesNames)
   const basicInfoState = useSelector((state: AppState) => state.formState[FormNames.BasicInfoForm])
   const appConsents = useSelector((state: AppState) => state.consentState.appConsents)
   const loanCalculatorState = useSelector((state: AppState) => state.loanCalculatorState)
   const { currentUrlFormPath, setCurrentUrlFormPath } = useContext(CurrentFormUrlPathContext)


   const { getAppConfiguration, getAppConsents } = useAppInitLogic(APP_INIT_TYPES.BASIC_INFO_FORM)



   const handleBasicInfoFormSubmit = () => {
      const hasUserSession = Boolean(sessionStorage.get(STORAGEKEYS.USER_SESSION))
      const cookie = new Cookies()

      dispatch({
         type: APP_CONSENTS_VALIDATE_ALL,
      })


      const hasConsentsError = appConsents.some(appConsent => appConsent.isRequired && !appConsent.isChecked)
      
      if(hasConsentsError){
         const scrollToErrorInput: Element = document.getElementsByClassName(Environment.appConsentsErrorClassName)[0]
         
         if(scrollToErrorInput !== undefined) {
            scrollToErrorInput.scrollIntoView({ behavior:"smooth", block: "center" })
         }
         
         return
      }
      else { 
         if(!hasUserSession){
            (async () => {
               const affiliateData: IAffiliateDataModel | undefined = cookie.get(STORAGEKEYS.FORM_AFFILIATE_DATA_COOKIE)

               const createApplicationParams: ILoanInitCreateApplicationParams = {
                  userEmail: basicInfoState.fieldsData[BasicInfoFieldsNames.Email].value as string,
                  amountToPay: loanCalculatorState.requestedAmount,
                  instalmentNumber: loanCalculatorState.instalments,
                  ...(affiliateData?.alternativeOffertNameFromFront && { // Jeśli `affiliateData` jest undefined, nie dodajemy klucza `alternativeOffertNameFromFront`, w przeciwnym wypadku dodajemy
                     alternativeOffertNameFromFront: affiliateData.alternativeOffertNameFromFront,
                  }),
               }

               apphistory.push(AppLinks.waiting)

               try {
                  const response = await loanInitService.createApplication(createApplicationParams)
      
                  if(response.redirectUrl?.length){
                     const redirectUrlPath = response.redirectUrl.slice(response.redirectUrl.indexOf("/start?"))
                     apphistory.push(redirectUrlPath)
                  }
               }
               catch (e: any){
                  const ERROR_ANALYTICS_DATA = {
                     id: analyticsService.DISPLAY_ERROR_PAGE_IDS.BASIC_INFO_FORM_PAGE_CREATE_APPLICATION,
                     reason: `Nie udało się stworzyć aplikacji, po wypełnieniu pierwszej strony formularza: (${ AppLinks.basicInfoForm }).`,
                     details: {
                        description: e.message,
                        errorDataFromBackend: e?.data,
                        additionalData: {
                           description: 'Parametry wysłane do backendu w requeście tworzącym aplikację (/createApp)',
                           createApplicationParams
                        }
                     },
                  }

                  dispatch({ type: SET_APP_HAS_ERROR }) //Ustawiamy globalny błąd aplikacji co spowoduje przejście na ekran z błędem
                  await analyticsService.createSingleAnalyticEvent(ANALYTICS_EVENT_TYPES_NAMES?.FrontendErrorPageDisplayed, JSON.stringify(ERROR_ANALYTICS_DATA, undefined, 3))
               }

            })()
         }
         else { //Jeśli użytkownik "powraca" do procesu z linku, będzie miał token, w takiej sytuacji bez dodatkowych akcji kierujemy go na kojelną stronę formularza.
            setCurrentUrlFormPath(AppLinks.extendedInfoForm)
            apphistory.push(AppLinks.extendedInfoForm)
         }

      }
   }

   useEffect(() => { // Inicjalizacja kalkulatora ze wstępną ofertą na pierwszej stronie formularza danymi z Backendu
      //W momencie gdy strona się wyrenderuje a adres nie zgadza się z obecnym adresem na którym powinien być użytkownik
      //robimy redirect na poprawny adres (cofamy użytkownika na poprawny adres, blokujemy wejście "z palca" na stronę).
      if(!isEmpty(currentUrlFormPath) && currentUrlFormPath !== basicInfoForm.urlPath){
         apphistory.push(currentUrlFormPath)

         return
      }

      sessionStorage.changeItemValue(STORAGEKEYS.CURRENT_PAGE_STEP, ApplicationStates.FORM.toString()); // Zmieniamy "krok" steppera strony
      
      (async () => {
         const basicInfoQueryParams: IBasicFormQueryParams = {
            requestedAmountFromParams: basicFormQuery.get('requestedAmount'),
            instalmentsFromParams: basicFormQuery.get('instalments')
         }
         try {
            await getAppConfiguration()
            await getAppConsents()

            const affiliatePartnerIdFromCookie = cookie.get(STORAGEKEYS.FORM_AFFILIATE_DATA_COOKIE)?.partnerId ?? null
            const isPredefinedPeriodsAvailable = enablePredefinedPeriodsLogicForAffiliatePartner(dispatch, affiliatePartnerIdFromCookie) // [ZAŁOŻENIE BIZNESOWE] - MECHANIZM PREDEFINIOWANYCH OKRESÓW POŻYCZKI

            await retryRequestOnError(() => formInitialization({ dispatch, loanInitService, basicInfoQueryParams, loanCalculatorState, IS_PREDEFINED_PERIODS_AVAILABLE: isPredefinedPeriodsAvailable }), 2)
         }
         catch(e: any) {
            const ERROR_ANALYTICS_DATA = {
               id: analyticsService.DISPLAY_ERROR_PAGE_IDS.BASIC_INFO_FORM_PAGE_PAGE_INITIALIZATION,
               reason: `Błąd podczas inicjalizacji aplikacji, po wejściu na ekran pierwszego formularza (${ AppLinks.basicInfoForm }). Nie udało się pobrać konfiguracji aplikacji, zgód lub danych do kalkulatora pożyczki.`,
               details: {
                  description: e.message,
                  errorDataFromBackend: e?.data,
               },
            }
            
            dispatch({ type: SET_APP_HAS_ERROR }) //Ustawiamy globalny błąd aplikacji co spowoduje przejście na ekran z błędem
            await analyticsService.createSingleAnalyticEvent(ANALYTICS_EVENT_TYPES_NAMES?.FrontendErrorPageDisplayed, JSON.stringify(ERROR_ANALYTICS_DATA, undefined, 3))
         }
     })()

   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])


   return {
      handleBasicInfoFormSubmit,
      setCurrentUrlFormPath,
      basicInfoState,

      isOffertReady: loanCalculatorState.isOffertReady,
   }
}

export default useBasicInfoFormLogic